import {InputRule, inputRules, textblockTypeInputRule, wrappingInputRule} from 'prosemirror-inputrules';
import {markInputRule} from "./helper/prosemirrorInputRules";

const blockQuoteRule = function (nodeType) {
    return wrappingInputRule(/^\s*>\s$/, nodeType);
};

const orderedListRule = function (nodeType) {
    return wrappingInputRule(/^\s*(\d+)[.)]\s$/, nodeType,
        match => ({order: +match[1]}),
        (match, node) => node.childCount + node.attrs.order === +match[1]);
};

const bulletListRule = function (nodeType) {
    return wrappingInputRule(/^\s*([-+*])\s$/, nodeType);
};

const headingRule = function (nodeType, maxLevel) {
    return textblockTypeInputRule(new RegExp("^\\s*(#{1," + maxLevel + "})\\s$"),
        nodeType, match => ({level: match[1].length}));
};

const strongRules = function (markType) {
    return [markInputRule(/(?:^|[^*\\]+)(\*\*([^*]+)\*\*)$/, markType),
        markInputRule(/(?:^|[^_\\]+)(__([^_]+)__)$/, markType)];
};

const emRules = function (markType) {
    return [markInputRule(/(?:^|[^_\\])(_([^_]+)_)$/, markType),
        markInputRule(/(?:^|[^*\\])(\*([^*]+)\*)$/, markType)];
};

const horizontalRule = nodeType => new InputRule(/^\s*(?:---|___|\*\*\*)$/,
    (state, match, start, end) => {
        const {tr} = state;

        if (match[0]) {
            tr.replaceWith(start - 1, end, nodeType.create({}));
        }

        return tr;
    });

export const buildInputRules = (state, nodeInputRules, markInputRules) => {
    const rules = [];
    rules.push(blockQuoteRule(state.schema.nodes.blockquote));
    rules.push(orderedListRule(state.schema.nodes.ordered_list));
    rules.push(bulletListRule(state.schema.nodes.bullet_list))
    rules.push(headingRule(state.schema.nodes.heading, 6));
    rules.push(horizontalRule(state.schema.nodes.horizontal_rule));
    rules.push(...emRules(state.schema.marks.em));
    rules.push(...strongRules(state.schema.marks.strong));

    return inputRules({
        rules: [...rules, ...nodeInputRules, ...markInputRules]
    });
};